import React, { useState } from 'react';
import './Faq.css';
import chatBubbleA from '../assets/images/msg-icon.png';
import chatBubbleB from '../assets/images/mchat.png';
import chatBubbleC from '../assets/images/mesg-set.png';
import Contact from '../page/Contact';

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const [isContactOpen, setIsContactOpen] = useState(false);

  const faqs = [
    {
      question: "Is this a dating event?",
      answer: "Mulaqaat is a curated social experience designed for real conversations. There's no pressure, no forced matching, and no expectations."
    },
    {
      question: "Will there be awkward activities or games?",
      answer: "Not at all. The environment is relaxed and natural. We focus on creating comfortable spaces for organic conversations, not forced ice-breakers."
    },
    {
      question: "What should I expect at the event?",
      answer: "Expect a premium venue, carefully curated guest list, and a relaxed atmosphere. You'll have the opportunity to engage in meaningful conversations with like-minded individuals."
    },
    {
      question: "How are guests selected?",
      answer: "We carefully curate our guest list to ensure a balanced, diverse, and compatible crowd. This helps create the best environment for genuine connections."
    }
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        {/* Left Side */}
        <div className="faq-left">
          <div className="faq-badge">Still Confused, Let us Answer</div>
          <div className="faq-title">Frequently Asked <br /> Questions</div>

          {/* Chat Icons Background */}
          <div className="chat-icons">
            <span className="chat-icon icon-1">
              <img src={chatBubbleA} alt="Chat bubble" />
            </span>
            <span className="chat-icon icon-2">
              <img src={chatBubbleB} alt="Chat bubble" />
            </span>
            <span className="chat-icon icon-3">
              <img src={chatBubbleC} alt="Chat bubble" />
            </span>
            <span className="chat-icon icon-4">
              <img src={chatBubbleB} alt="Chat bubble" />
            </span>
            <span className="chat-icon icon-5">
              <img src={chatBubbleC} alt="Chat bubble" />
            </span>
            <span className="chat-icon icon-6">
              <img src={chatBubbleB} alt="Chat bubble" />
            </span>
            <span className="chat-icon icon-7">
              <img src={chatBubbleB} alt="Chat bubble" />
            </span>
            <span className="chat-icon icon-8">
              <img src={chatBubbleC} alt="Chat bubble" />
            </span>

              <span className="chat-icon icon-9">
              <img src={chatBubbleC} alt="Chat bubble" />
            </span>
            <span className="chat-icon icon-10">
              <img src={chatBubbleB} alt="Chat bubble" />
            </span>
            <span className="chat-icon icon-11">
              <img src={chatBubbleA} alt="Chat bubble" />
            </span>
            <span className="chat-icon icon-12">
              <img src={chatBubbleB} alt="Chat bubble" />
            </span>
          </div>

          {/* Contact Card */}
          <div className="contact-card">
            <h3 className="contact-title">Still have questions?</h3>
            <p className="contact-description">
              can't find the answer to your questions? send us an email and we will get back to you as soon as possible.
            </p>
            <button
              type="button"
              className="contact-button"
              onClick={() => setIsContactOpen(true)}
            >
              Talk to Us
            </button>
          </div>
        </div>

        {/* Right Side - FAQ Items */}
        <div className="faq-right">
          <div className="faq-timeline"></div>
          
          {faqs.map((faq, index) => (
            <div key={index} className={`faq-item ${openIndex === index ? 'active' : ''}`}>
              <div className="faq-dot">
                <div className="faq-dot-inner"></div>
              </div>
              
              <div className="faq-card" onClick={() => toggleFaq(index)}>
                <div className="faq-header">
                  <h3 className="faq-question">{faq.question}</h3>
                  <button className="faq-toggle">
                    <svg 
                      width="26" 
                      height="19" 
                      viewBox="0 0 26 19" 
                      fill="none"
                      className={openIndex === index ? 'rotated' : ''}
                    >
                      <path d="M13 19L0.00961876 0.25L25.9904 0.25L13 19Z" fill="rgba(246, 149, 117, 0.4)"/>
                    </svg>
                  </button>
                </div>
                
                {openIndex === index && (
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      {isContactOpen && <Contact onClose={() => setIsContactOpen(false)} />}
    </section>
  );
};

export default Faq;
